<!-- <div class="submenu-inner" [ngClass]="{'three-col': submenu.length > 30}"> -->
    <div class="submenu-item"
         *ngFor="let submenuItem of submenu">
        <div class="mitem" [menuItem]="submenuItem"></div>
    </div>
<!-- </div> -->
